import { initialState } from './index';
import { RootState } from '../../../root-saga/root-state';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state['chat'] || initialState;

export const selectIsLoading = createSelector([selectDomain], (state) => state.isLoading);
export const selectCurrentSessionId = createSelector([selectDomain], (state) => state.currentSessionId);
export const SelectMessages = createSelector([selectDomain], (state) => state.messages);
export const selectTemporarySessionId = createSelector([selectDomain], (state) => state.temporarySessionId);
